const abTestDefaults = {
  experiments: [],
  __typename: 'ClientABTests',
};

export default abTestDefaults;
